
import { Session } from '@supabase/supabase-js';

export const cacheSession = (session: Session | null): void => {
  if (session) {
    localStorage.setItem('supabase.auth.session', JSON.stringify(session));
  } else {
    localStorage.removeItem('supabase.auth.session');
  }
};

export const getCachedSession = (): Session | null => {
  const cachedSession = localStorage.getItem('supabase.auth.session');
  if (cachedSession) {
    try {
      return JSON.parse(cachedSession);
    } catch (error) {
      console.error('Error parsing cached session:', error);
      return null;
    }
  }
  return null;
};

export const isGuestUser = (session: Session | null): boolean => {
  return session?.user?.app_metadata?.provider === 'anonymous';
};
